import { useEffect } from "react";
import "./AtivarDesvio.css";

export default function AtivarDesvio({
  open,
  titulo,
  descricao,
  onClose,
  onConfirmar,
  onConfirm,
}) {
  if (!open) return null;

  const submit = onConfirmar || onConfirm || (() => {});

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Escape") onClose?.();
    if (e.key === "Enter") submit();
  };

  return (
    <div className="dvok-bg" onKeyDown={handleKeyDown}>
      <div className="dvok-box" role="dialog" aria-modal="true" aria-label="Ativar desvio">
        <header className="dvok-head">
          <h3 className="dvok-title">Ativar</h3>
          <button className="dvok-x" type="button" onClick={onClose} aria-label="Fechar">x</button>
        </header>

        <div className="dvok-body">
          {descricao ? descricao : <>Deseja <strong>ativar</strong> "{titulo || "este item"}"?</>}
        </div>

        <footer className="dvok-foot">
          <button className="dvok-btn" type="button" onClick={onClose}>Cancelar</button>
          <button className="dvok-btn dvok-btn-ok" type="button" onClick={submit}>Ativar</button>
        </footer>
      </div>
    </div>
  );
}
